import { LoginService } from './../services/login.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';
import { sha256 } from 'js-sha256';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    token: string;

  constructor(private loginService: LoginService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    this.token = this.loginService.getToken();
    const body = JSON.stringify(request.body);
    // tslint:disable-next-line:max-line-length
    const checksum  = sha256.hmac(`${environment.secretKey}`, body);
    request = request.clone({
        setHeaders: {
          accesskey: `${environment.accessKey}`,
          checksum: `${checksum}`,
          Authorization: `Bearer ${this.token}`
        }
    });
    return next.handle(request);
  }
}
